/* eslint-disable max-len */
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, Modal } from '@mui/material';
import { styled } from '@mui/system';

import '../add-report-modal/index.scss';
import Color from '@tool/color';
import moStore, { toggleConcatModal } from '@store/index';
import { CloseIcon20 } from '@styled/icon';
import moUser from '@store/user';
import posthog from 'posthog-js';
import Service from '@service/index';
import moSkin from '@store/skin';

interface IProps { }
interface IState { }

const SubButton = styled(Button)(() => ({
  width: '180px',
  height: '36px',
  borderRadius: '18px',
  background: Color.secondaryColor(1),
  // display: 'flex',
  // justifyContent: 'space-between',
  padding: '0 20px',
  color: Color.white,
  '&:hover': {
    backgroundColor: Color.secondaryColor(1),
  },
  '& svg': {
    marginLeft: '10px',
  },
}));

const NextButton = styled(Button)(() => ({
  width: '180px',
  height: '36px',
  borderRadius: '20px',
  background: Color.fff,
  padding: '0 20px',
  border: `1px solid ${Color.ec}`,
  color: Color.c55,
  '& svg': {
    marginLeft: '10px',
  },
}));

const AddConcatModal = (props: IProps, state: IState) => {
  const { isContactModal } = moStore;
  const onSure = () => {
    posthog.capture('无次数弹窗-直接联系顾问按钮', {});
    toggleConcatModal(false);
  };
  const cancel = () => {
    toggleConcatModal(false);
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <Modal open={isContactModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <section className="add-report-warp">
        <section className="add-report-content">
          <p className="prompt">提示
            <span onClick={() => cancel()} aria-hidden="true"><CloseIcon20 /></span>
          </p>
          <p style={{ marginTop: '20px', fontSize: '12px', textAlign: 'center' }}>
            如需获取更多的市场薪酬数据与专业的薪酬指导，请联系我们的薪酬专家顾问
          </p>
          <p className="telephone" style={{ marginTop: '20px' }}>
            顾问专属电话：{moSkin?.counselor?.phoneNum}
          </p>
        </section>
      </section>
    </Modal>
  );
};

export default observer(AddConcatModal);
